<template>
  <div class="event" :style="{backgroundColor: color}">
    <img v-if="image" class="event__bg-img" :src="image" :alt="name">
    <div class="event__container">
      <div class="event__type">{{ type }}</div>
      <div class="event__name">{{ name }}</div>
      <div class="event__date">
        {{ eventDate.format('DD MMMM YYYY') }}
        <span>-</span>
        {{ eventDate.format('dd HH:mm').toUpperCase() }}
      </div>
      <div class="event__actions">
        <a :href="to" class="btn btn_primary">Купить билет </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { computed } from 'vue';

import 'dayjs/locale/ru';

dayjs.locale('ru');
dayjs.extend(utc);
dayjs.extend(timezone);

const props = defineProps({
  type: {
    type: String,
    default: '',
  },
  date: {
    type: Number,
    default: Date.now(),
  },
  name: {
    type: String,
    default: '',
  },
  image: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: '',
  },
  to: {
    type: String,
    default: '',
  },
});
const eventDate = computed(() => {
  return dayjs.tz(props.date, 'Europe/Moscow');
}) 

</script>

<style scoped lang="scss">
    .event {
        border-radius: 20px;
        position: relative;
        height: 100%;
        width: 100%;
        overflow: hidden;
        background-image: url('../../../../images/site/pattern2.png');
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: top;

        &__type {
            padding: 6px 18px;
            background-color: $grey;
            display: inline-block;
            border-radius: 16px;
            font-size: 10px;
            align-self: start;
            justify-self: start;
        }

        &__bg-img {
            position: absolute;
            width: 100%;
            height: 100%;
            inset: 0;
            object-fit: cover;
        }

        &__container {
            background-color: rgba($color: $black, $alpha: .3);
            position: relative;
            width: 100%;
            height: 100%;
            padding: 20px;
            display: flex;
            flex-direction: column;
            gap: 16px;
        }

        &__name {
            font-size: 32px;
            color: $white;
            font-weight: 700;
            margin-top: auto;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &__date {
            color: $white;
            font-size: 14px;

            span {
                color: $primary;
                font-size: 24px;
                line-height: 16px;
            }
        }

        &__actions {
            a {
                display: inline-block;
                width: 100%;
                text-align: center;
            }
        }
    }
</style>
